export default "__VITE_ASSET__DK5Thsk6__"